import { utl_pageId, utl_pageClass } from "../base/_utils";

export default function animateHeaderInit() {
    /* ========= ANIMATE INTERIOR PAGE TITLE ON LOAD ======== */
    const runAnimateHeader = () => {
        const pageTitle = document.querySelector(".interior-header-title");
        const headerImg = document.querySelector(".interior-header-img-wrapper");

        // document.addEventListener("DOMContentLoaded", () => {
        pageTitle.classList.add("interior-header-title-animate");
        headerImg.classList.add("interior-header-img-animate");
        // });
    };

    /* ============ Only run code if on page other than these =========== */
    if (utl_pageId() !== "main-index" && utl_pageId() !== "thank-you" && !utl_pageClass().contains("story")) {
        runAnimateHeader();
    }
}
